import { PageInfo } from '../../share-types'
import { IOneTimeCodeBatch } from '../one-time-code-batches-container/share-type'

export type IOneTimeCode = {
  id: number
  code: string
  redeemedById: number | null
  redeemedByUser: string | null
  redeemedAt: string | null
  createdAt: string
  updatedAt: string
  status: string
  batch: IOneTimeCodeBatch
}

export type PaginatedOneTimeCodesResponse = {
  pageInfo: PageInfo
  data: IOneTimeCode[]
}

export type IOneTimeCodesFilterParams = {
  batchName?: string
  batchId?: number
  code?: string
  isRedeemed?: boolean
  redeemedById?: number
  startDate?: string
  endDate?: string
  orderBy?: OneTimeCodesFilterOrder
}

export enum OneTimeCodesFilterOrder {
  ID = 'ID',
  REDEEMED_AT = 'REDEEMED_AT',
}

export type IPaginatedOneTimeCodesParams = {
  page: number
  size: number
} & IOneTimeCodesFilterParams
